<ui-checkbox
  [model]="isSubscribe"
  (modelChange)="onChange.emit($event)">
  {{ 'auth.subscribeOnNews' | translate}}
</ui-checkbox>
